"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _IconButton = _interopRequireDefault(require("../IconButton"));

var _ClickAwayListener = _interopRequireDefault(require("../ClickAwayListener"));

var _Options = _interopRequireDefault(require("@p24/icons/Options"));

var _mergeTheme = _interopRequireDefault(require("../style/mergeTheme"));

var _root = _interopRequireDefault(require("./style/root"));

var _list = _interopRequireDefault(require("./style/list"));

var Options = function Options(_ref) {
  var dirLeft = _ref.dirLeft,
      render = _ref.render,
      theme = _ref.theme,
      style = _ref.style,
      disabled = _ref.disabled,
      children = _ref.children;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      active = _useState2[0],
      setActive = _useState2[1];

  var root = (0, _react.useRef)(null);
  var handleClickAway = (0, _react.useCallback)(function (event) {
    var _root$current;

    if (active && !((_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.contains(event.target))) {
      setActive(false);
    }
  }, [active, root.current]);
  var memoTheme = (0, _react.useMemo)(function () {
    return (0, _mergeTheme["default"])(theme, style);
  }, [theme, style]);
  var handleClick = (0, _react.useCallback)(function () {
    return disabled ? null : setActive(!active);
  }, [active, disabled]);
  var handleClose = (0, _react.useCallback)(function () {
    return setActive(false);
  }, []);
  (0, _react.useEffect)(function () {
    if (active && disabled) {
      setActive(false);
    }
  }, [disabled]);
  var button = (0, _react.useMemo)(function () {
    var icon = _react["default"].createElement(_IconButton["default"], {
      disabled: disabled
    }, _react["default"].createElement(_Options["default"], null));

    if (typeof render === 'function') {
      return render({
        icon: icon,
        disabled: disabled
      });
    } else {
      return icon;
    }
  }, [render, disabled]);
  return _react["default"].createElement(_root["default"], {
    theme: memoTheme,
    ref: root
  }, active ? _react["default"].createElement(_ClickAwayListener["default"], {
    node: root.current,
    onClickAway: handleClickAway
  }) : null, _react["default"].createElement("div", {
    onClick: handleClick
  }, button), active ? _react["default"].createElement(_list["default"], {
    theme: memoTheme,
    dirLeft: dirLeft
  }, _react["default"].Children.map(children, function (child, i) {
    if (child) {
      return _react["default"].createElement("div", {
        key: i,
        onClick: handleClose
      }, child);
    }
  })) : null);
};

Options.defaultProps = {
  dirLeft: true
};
Options.propTypes = {
  dirLeft: _propTypes["default"].bool,
  render: _propTypes["default"].func,
  disabled: _propTypes["default"].bool,
  children: _propTypes["default"].any,

  /**
   * Basic style
   */
  theme: _propTypes["default"].shape({
    /**
     * @default palette.tFilled
     */
    color: _propTypes["default"].string,

    /**
     * @default palette.elPrimary
     */
    listBackground: _propTypes["default"].string,

    /**
     * @default 0 6px 10px 0 ${palette.elShadow}, 0 4px 10px 0 ${palette.elShadow}
     */
    listBoxShadow: _propTypes["default"].string,

    /**
     * @default palette.zOverlay
     */
    listZIndex: _propTypes["default"].number,

    /**
     * @default palette.tFilled
     */
    itemColor: _propTypes["default"].string,

    /**
     * @default transparent
     */
    itemBackground: _propTypes["default"].string,

    /**
     * @default palette.gutter + 'px'
     */
    itemPaddingBottom: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default palette.gutter + 'px'
     */
    itemPaddingTop: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default palette.gutter * 2 + 'px'
     */
    itemPaddingLeft: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default palette.gutter * 2 + 'px'
     */
    itemPaddingRight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default palette.tFilled
     */
    focusItemColor: _propTypes["default"].string,

    /**
     * @default transparent
     */
    focusItemBackground: _propTypes["default"].string,

    /**
     * @default palette.tFilled
     */
    hoverItemColor: _propTypes["default"].string,

    /**
     * @default palette.elLightest
     */
    hoverItemBackground: _propTypes["default"].string,

    /**
     * @default palette.tActive
     */
    activeItemColor: _propTypes["default"].string,

    /**
     * @default palette.elLightest
     */
    activeItemBackground: _propTypes["default"].string
  })
};
var _default = Options;
exports["default"] = _default;